module.exports = __webpack_public_path__ + "img/40.1b772fb3.svg";